import { render, staticRenderFns } from "./callMatch.vue?vue&type=template&id=b3f7efa4&scoped=true&"
import script from "./callMatch.vue?vue&type=script&lang=js&"
export * from "./callMatch.vue?vue&type=script&lang=js&"
import style0 from "./callMatch.vue?vue&type=style&index=0&id=b3f7efa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f7efa4",
  null
  
)

export default component.exports